export default{
  aigc_common_search: "搜索",
  aigc_common_all: "全部",
  aigc_common_expand: "展开",
  aigc_common_expand_all: "展开全部",
  aigc_common_retract: "收起",
  aigc_common_other: "其 他",
  aigc_common_delete: "删除",
  aigc_common_delete_success: "删除成功",
  aigc_common_delete_fail: '删除失败',
  aigc_common_edit: "编辑",
  aigc_common_error_info: "错误，错误代码 {code}",
  aigc_common_confirm: "确认",
  aigc_common_cancel: "取消",
  aigc_common_release_mouse: "释放鼠标",
  aigc_common_upload_size: "文件大小：",
  aigc_common_upload_date: "上传日期：",
  aigc_common_upload_cancel: "取消上传",
  aigc_common_re_upload: "重新上传",
  aigc_common_upload_click: "点击上传",
  aigc_common_upload_drag: "/拖拽到此区域",
  aigc_common_game: '游戏',
  aigc_common_loading: '加载中...',
  dba_token_monthly_quota: '本月模型额度',
  dba_token_used_label: '已用',
  dba_token_quota_tip: '本月已使用 {used} / {total} USD',
  dba_token_quota_tooltip: '该模型额度为DataBrain平台专属额度，与公司额度不互通，达到高级模型用量上限后，系统将切换至基础模型服务，继续支持后续使用。',
};
